import React, { useContext } from 'react';
import { Button, IconButton, SvgIcon, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataSpaceViewContext } from '../context/DataSpaceViewContext';
import getDataSpaceImageLink from '../../../utils/getDataSpaceImageLink';
import MyDataSpacesViewContext from '../context/MyDataSpacesViewContext';
import getDataSpaceLogo from '../../../utils/getDataSpaceLogo';
import TwitterIcon from '@material-ui/icons/Twitter';
import WebsiteIcon from '@material-ui/icons/Language';
import RedditIcon from '@material-ui/icons/Reddit';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import { ReactComponent as TikTokIcon } from '../../../assets/icons/tiktok.svg';
import DefaultProfilePng from '../../../assets/img/DefaultProfile.png';

const useStyles = makeStyles((theme) => ({
	headerWrapper: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		gap: '0.25rem',
		padding: '0.5rem',
		backgroundSize: 'auto 100%',
		backgroundPosition: 'right',
		backgroundRepeat: 'no-repeat',
		color: '#495057',
		'@media (max-width: 768px)': {
			textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
		},
		'@media (max-width: 500px)': {
			flexDirection: 'column',
			alignItems: 'flex-start',
		},
	},
	socialMediaButton: {
		backgroundColor: '#E9E9E9',
		padding: '0.25rem',
		color: '#1C95E0',
	},
	socialMediaIcon: {
		color: '#1C95E0',
		fontSize: '0.9rem',
	},
	shareButton: {
		'@media (max-width: 500px)': {
			width: '100%',
			maxWidth: '30rem',
		},
	},
	callToActionButtonWrapper: {
		whiteSpace: 'nowrap',
		'@media (max-width: 500px)': {
			width: '100%',
			maxWidth: '30rem',
			'& > button': {
				width: '100%',
				maxWidth: '30rem',
			},
		},
	},
}));

const DataSpaceViewHeader = (props) => {
	const classes = useStyles();

	const dataSpaceViewContext = useContext(DataSpaceViewContext);
	const myDataSpacesViewContext = useContext(MyDataSpacesViewContext);

	let author = dataSpaceViewContext.dataSpace.originalAuthor || dataSpaceViewContext.dataSpace.createdBy;

	return (
		<div
			className={classes.headerWrapper}
			style={{
				backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0.2) 0%, rgba(255,255,255,0.2) 100%), linear-gradient(to left, transparent 5rem, #FFFFFF 25rem), linear-gradient(to left, transparent 5rem, #FFFFFF 25rem), url(${
					dataSpaceViewContext.dataSpace.dataSpaceImageUrl || getDataSpaceImageLink(dataSpaceViewContext.dataSpace)
				})`,
			}}
		>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'end',
					gap: '0.5rem',
				}}
			>
				<img
					src={getDataSpaceLogo(dataSpaceViewContext.dataSpace)}
					alt="DataSpace Logo"
					style={{
						height: '3.5rem',
						borderRadius: '0.25rem',
						border: '1px solid white',
					}}
				/>

				<div style={{ width: '100%', padding: '0.2rem 0', minWidth: 0 }}>
					<Typography
						style={{
							fontWeight: 700,
							fontSize: '1.25rem',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							width: '100%',
						}}
					>
						{dataSpaceViewContext.dataSpace.name}
					</Typography>

					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							style={{ height: '1.3rem', borderRadius: '50%', marginRight: '0.5rem' }}
							src={author.userProfileImageUrl || DefaultProfilePng}
							alt="Proflie picture."
						/>

						<span style={{ fontWeight: 700, fontSize: '0.8rem' }}>{author.username}</span>

						<div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', marginLeft: '0.5rem' }}>
							{author.website && (
								<IconButton className={classes.socialMediaButton} onClick={() => window.open(author.website, '_blank')}>
									<WebsiteIcon className={classes.socialMediaIcon} />
								</IconButton>
							)}
							{author.twitter && (
								<IconButton
									className={classes.socialMediaButton}
									onClick={() => window.open(`https://x.com/${author.twitter}`, '_blank')}
								>
									<TwitterIcon className={classes.socialMediaIcon} />
								</IconButton>
							)}
							{author.reddit && (
								<IconButton
									className={classes.socialMediaButton}
									onClick={() => window.open(`https://www.reddit.com/user/${author.reddit}`, '_blank')}
								>
									<RedditIcon className={classes.socialMediaIcon} />
								</IconButton>
							)}
							{author.linkedIn && (
								<IconButton
									className={classes.socialMediaButton}
									onClick={() => window.open(`https://www.linkedin.com/in/${author.linkedIn}`, '_blank')}
								>
									<LinkedInIcon className={classes.socialMediaIcon} />
								</IconButton>
							)}
							{author.instagram && (
								<IconButton
									className={classes.socialMediaButton}
									onClick={() => window.open(`https://www.instagram.com/${author.instagram}`, '_blank')}
								>
									<InstagramIcon className={classes.socialMediaIcon} />
								</IconButton>
							)}
							{author.tikTok && (
								<IconButton
									className={classes.socialMediaButton}
									onClick={() => window.open(`https://www.tiktok.com/@${author.tikTok}`, '_blank')}
								>
									<SvgIcon className={classes.socialMediaIcon}>
										<TikTokIcon />
									</SvgIcon>
								</IconButton>
							)}
						</div>
					</div>
				</div>
			</div>

			{props.callToActionButton ? (
				<div className={classes.callToActionButtonWrapper}>{props.callToActionButton}</div>
			) : (
				<Button
					variant="contained"
					onClick={() => {
						myDataSpacesViewContext.setIsShareDataSpaceDialogOpen(true);
					}}
					style={{ height: 'fit-content' }}
					className={classes.shareButton}
				>
					Share
				</Button>
			)}
		</div>
	);
};

export default DataSpaceViewHeader;
